import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Interactive } from "react-interactive";
import { CSSTransition } from "react-transition-group";
import useHandleInteractiveStateChange from "~hooks/use_handle_interactive_state_change/use_handle_interactive_state_change";
import { BLOK_ARRAY } from "../../../../../prop_types";
import * as transitionScaleFadeAppear from "../../../../../styles/global_scss_modules/global_css_transition_styles/transition_scale_fade_appear.module.scss";
import TOCChaptersModalController from "../toc_chapters_modal_controller/toc_chapters_modal_controller";
import TOCDownloadModalController from "../toc_download_modal_controller/toc_download_modal_controller";
import TOCLink from "../toc_link/toc_link";
import {
  innerStyle,
  isActiveStyle,
  wrapperStyle,
} from "./toc_nav_desktop.module.scss";

const TRANSITION_CLASSNAMES = { ...transitionScaleFadeAppear };

const TRANSITION_TIMEOUT = {
  enter: 200,
  exit: 200,
};
function TOCNavDesktop({
  activeItem,
  allChaptersTitle,
  chapters,
  collectionTitle,
  currentChapterIndex,
  downloadButtonText,
  downloadFormDescription,
  downloadFormId,
  downloadFormTitle,
  isVisible,
  lang,
  pagePath,
  sections,
}) {
  const [isActive, handleInteractiveStateChange] =
    useHandleInteractiveStateChange();

  const wrapperClassNames = classNames(wrapperStyle, {
    [isActiveStyle]: isActive,
  });

  return (
    <CSSTransition
      timeout={TRANSITION_TIMEOUT}
      classNames={TRANSITION_CLASSNAMES}
      in={isVisible}
      appear
      unmountOnExit
    >
      <Interactive
        as="div"
        className={wrapperClassNames}
        onStateChange={handleInteractiveStateChange}
      >
        <>
          <TOCChaptersModalController
            {...{
              allChaptersTitle,
              chapters,
              collectionTitle,
              currentChapterIndex,
              isNavExpanded: isActive,
              pagePath,
            }}
          />
          <div className={innerStyle}>
            {sections?.length > 2 &&
              sections.map((chapter) => {
                return (
                  <TOCLink
                    activeItem={activeItem}
                    key={chapter.title}
                    title={chapter.title}
                    pagePath={pagePath}
                    isNavExpanded={isActive}
                  />
                );
              })}
          </div>
          {downloadFormId && (
            <TOCDownloadModalController
              {...{
                downloadButtonText,
                downloadFormId,
                downloadFormTitle,
                downloadFormDescription,
                lang,
                isNavExpanded: isActive,
              }}
            />
          )}
        </>
      </Interactive>
    </CSSTransition>
  );
}

TOCNavDesktop.propTypes = {
  activeItem: PropTypes.string,
  allChaptersTitle: PropTypes.string,
  chapters: BLOK_ARRAY,
  collectionTitle: PropTypes.string,
  currentChapterIndex: PropTypes.number,
  downloadButtonText: PropTypes.string,
  downloadFormDescription: PropTypes.string,
  downloadFormId: PropTypes.string,
  downloadFormTitle: PropTypes.string,
  isVisible: PropTypes.bool,
  lang: PropTypes.string,
  pagePath: PropTypes.string,
  sections: BLOK_ARRAY,
};

TOCNavDesktop.defaultProps = {
  activeItem: null,
  allChaptersTitle: null,
  chapters: null,
  collectionTitle: null,
  currentChapterIndex: null,
  downloadButtonText: null,
  downloadFormDescription: null,
  downloadFormId: null,
  downloadFormTitle: null,
  isVisible: false,
  lang: "en-gb",
  pagePath: null,
  sections: null,
};

export default TOCNavDesktop;
